<template>
	<section v-loading="loadingDM">
		<div class="d-flex mt-3 mb-3 flex-row-reverse">
			<el-popover placement="bottom" width="300" trigger="click">
				<el-checkbox-group v-model="fieldsShow">
					<el-checkbox :key="index" v-for="(key, index) in fields" :label="key.name">{{
							ReserveItemDM[key.name].show_name
					}}</el-checkbox>
				</el-checkbox-group>
				<el-button icon="el-icon-view" circle size="mini" slot="reference"></el-button>
			</el-popover>
		</div>
		<el-table
			:data="items"
			style="width: 100%;"
			v-loading="loadings.main"
			@sort-change="handleSortChange"
			size="small"
			:show-summary="showSummary"
			border
			v-if="hasGetData"
			@selection-change="handleSelectionChange"
		>
			<el-table-column v-if="showSelect"
					type="selection"
					width="55">
			</el-table-column>
			<el-table-column
				:prop="key.name"
				:sortable="key.sortable"
				:label="ReserveItemDM[key.name].show_name"
				:key="index"
				:width="key.width"
				v-for="(key, index) in realFields"
			>
				<div slot-scope="scope">
					<field-show
						:field-info="ReserveItemDM[key.name]"
						:value="scope.row[key.name]"
						:field-key="key"
						:tooltip-img="key.needThumb ? scope.row[key.needThumb] : ''"
						:params="key.params"
						v-if="!key.render"
					></field-show>
					<span v-else v-html="key.render(scope.row)"></span>
				</div>
			</el-table-column>
			<el-table-column v-if="!showSelect"
					fixed="right"
					label="操作"
					width="100">
				<template slot-scope="scope">
					<el-button @click="handleClickBack(scope.row._id)" type="text" size="small">回退库存</el-button>
				</template>
			</el-table-column>
		</el-table>
		<editor
				:show.sync="editorVisible"
				data-model-name="Reserve_item"
				:fields="editorFields"
				:record-id="editorItemId"
				handler-url="reserve/do_rollback_item"
				@change="refreshData('listTable')"
		></editor>

		<div class="row" v-if="hasPage">
			<div class="col-lg-12 mt-3">
				<el-pagination
					layout="total,prev, pager, next, jumper"
					:total="paginations.main.total"
					:page-size="50"
					:current-page="paginations.main.pageNow"
					background
					@current-change="handlePageChange"
				></el-pagination>
			</div>
		</div>
	</section>
</template>

<script>
import CurdTable from "@/mixins/CurdTable.js";
import { mapState, mapGetters, mapMutations } from "vuex";
import ReserveItemDM from "@/datamodels/Reserve_item";

export default {
	mixins: [CurdTable],
	config: {
		ReserveItemDM,
	},
	data() {
		return {
      rate:0,
			items: [],
			fields: [
				{
					name: "show_id",
					sortable: "custom",
					needThumb: "thumb_img",
					params: {
						width: "120px",
					},
				},
				{
					name: "brand",
					sortable: "custom",
				},
				{
					name: "product_color",
					sortable: "custom",
					params: {
						width: "150px",
					},
				},
				{
					name: "color_name",
					sortable: "custom",
					params: {
						width: "3rem",
					},
				},
				{
					name: "model",
					sortable: "custom",
					params: {
						width: "3rem",
					},
				},
				{
					name: "amount",
					sortable: "custom",
					params: {
						isRight: true,
						isBold: true,
						isZeroSlash: true,
					},
				},
				{
					name: "storehouse"
				}
			],
			editorFields:[
				{
					name: "show_id",
					isOnlyShow: true,
				},
				{
					name: "brand",
					isOnlyShow: true,
				},
				{
					name: "product_color",
					isOnlyShow: true,
				},
				{
					name: "color_name",
					isOnlyShow: true,
				},
				{
					name: "model",
					isOnlyShow: true,
				},
				{
					name: "amount",
					isOnlyShow: true,
				},
				{
					name: "storehouse",
					isOnlyShow: true,
				},
				{
					name: "num",
					rules: ["required"],
				},
				{
					name: "warehouse",
					rules: ["required"],
				}
			],
			editorVisible: false,
			editorItemId: ""
		};
	},
	props: {
		storehouseFilter: {
			type: Object,
			default: function () {
				return {
					_id: "",
				};
			},
		},
		showSelect:{
			type:Boolean,
			default:false
		}
	},
	computed: {
		...mapState(["warehousesMapping", "userPrivilegeMapping"]),
		realFields() {
			let fieldShowFilter = {};
			this.fieldsShow.forEach((val) => {
				fieldShowFilter[val] = 1;
			});
			return this.fields.filter((key) => {
				if (key.privilege) {
					let orHavePri = false;
					key.privilege.forEach((pri) => {
						if (this.userPrivilegeMapping[pri]) {
							orHavePri = true;
						}
					});

					if (!orHavePri) {
						return false;
					}
				}

				if (!fieldShowFilter[key.name]) {
					return false;
				}
				return true;
			});
		},
		viewModels() {
			let models = {};
			for (let k in this.viewFields) {
				let val = this.viewFields[k];
				if (!val.table) {
					val.table = this.dataModel;
				}
				if (this.dataModels[val.table]) {
					models[val.name] = this.dataModels[val.table][val.name];
				}
			}

			return models;
		},
	},
	methods: {
		handleClickBack(id){
			this.editorVisible = true
			this.editorItemId = id
			console.log("handleClickBack:",id)
		},

		calcWarehouseName(id) {
			return this.warehousesMapping[id].name;
		},
		refreshData() {
			this.loadings.main = true;
			const url = this.listUrl ? "/" + this.listUrl : `/curd/lists/${this.dataModel}`;
			this.$axios
				.post(url, {
					page: this.hasPage ? this.paginations.main.pageNow : -999,
					sortKey: this.sorts.sortKey,
					sortOrder: this.sorts.sortOrder,
					searchFilter: this.searchFilter,
					dateFilter: this.dateFilter,
					kvFilter: this.kvFilter,
					storehouseFilter: this.storehouseFilter._id,
				})
				.then((json) => {
					this.loadings.main = false;

					this.items = json.data.datas;

					this.setPageTotal(json.data.pages.total);
					this.hasGetData = true;
				})
				.catch((json) => {
					this.loadings.main = false;
				});
		},
	},
	watch: {
		storehouseFilter(val) {
			this.refreshData();
		},
	},
};
</script>
<style lang="scss" scoped>
.expand .el-form-item {
	margin-right: 0;
	margin-bottom: 0;
	width: 50%;
}
.cell {
	.el-button {
		margin-bottom: 1em;
	}
}
</style>
